/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { datasetImportStatusColors } from '../constants/datasetImportStatusColors';
import { DatasetImportStatus } from '../types/dataset/DatasetImportStatus';

export const getDSImportStatusColor = (status: DatasetImportStatus): string =>
  datasetImportStatusColors[status] || datasetImportStatusColors.__fallback;
